let currentFocus = -1
let currentInput: HTMLInputElement | null = null

document.addEventListener('DOMContentLoaded', () => {
  const quicksearch = document.getElementById('quicksearchTextbox') as HTMLInputElement | null
  const quicksearchmobile = document.getElementById('quicksearchTextboxmobile') as HTMLInputElement | null

  if (quicksearch) setupAutocomplete(quicksearch)
  if (quicksearchmobile) setupAutocomplete(quicksearchmobile)
})

const setupAutocomplete = (inputElement: HTMLInputElement) => {
  inputElement.addEventListener('input', async () => {
    const term = inputElement.value.trim()
    if (term.length < 2) return

    try {
      const autocompleteRes = await fetch(`/find_v2/_autocomplete?prefix=${term}&size=4`)
      const autocompleteData = await autocompleteRes.json()

      const spellcheckRes = await fetch(`/find_v2/_spellcheck?query=${term}?size=1`)
      const spellcheckData = await spellcheckRes.json()

      let suggestions: { label: string; value: string }[] = []

      if (spellcheckData?.hits?.length > 0) {
        suggestions = spellcheckData.hits.map((item: { suggestion: string }) => ({
          label: item.suggestion,
          value: item.suggestion,
        }))
      }

      if (autocompleteData?.hits?.length > 0) {
        suggestions.push(...autocompleteData.hits.map((item: { query: string }) => ({
          label: item.query,
          value: item.query,
        })))
      }

      if (suggestions.length > 0) {
        currentFocus = -1
        currentInput = inputElement
        showSuggestions(inputElement, suggestions)
      }
    } catch (error) {
      console.error('Autocomplete error:', error)
    }
  })
}

document.addEventListener('keydown', (e) => {
  if (!currentInput) return
  const suggestionBox = document.getElementById(currentInput.id + '-autocomplete-list')
  if (!suggestionBox) return

  const items = suggestionBox.getElementsByTagName('li')
  if (!items.length) return

  if (e.key === 'ArrowDown') {
    currentFocus++
    addActive(items)
    e.preventDefault()
  } else if (e.key === 'ArrowUp') {
    currentFocus--
    addActive(items)
    e.preventDefault()
  } else if (e.key === 'Enter') {
    if (currentFocus > -1 && items[currentFocus]) {
      e.preventDefault()
      items[currentFocus].click()
    }
    // else: allow default Enter behavior for form submit
  } else if (e.key === 'Escape') {
    suggestionBox.innerHTML = ''
  }
})

function addActive(items: HTMLCollectionOf<HTMLLIElement>) {
  if (!items.length) return
  removeActive(items)
  if (currentFocus >= items.length) currentFocus = 0
  if (currentFocus < 0) currentFocus = items.length - 1
  items[currentFocus].classList.add('autocomplete-active')
  items[currentFocus].scrollIntoView({ block: 'nearest' }) // optional: scroll into view
}

function removeActive(items: HTMLCollectionOf<HTMLLIElement>) {
  Array.from(items).forEach((item) => item.classList.remove('autocomplete-active'))
}

const showSuggestions = (
  inputElement: HTMLInputElement,
  suggestions: { label: string; value: string }[]
) => {
  const suggestionBoxId = inputElement.id + '-autocomplete-list'
  let suggestionBox = document.getElementById(suggestionBoxId)

  if (!suggestionBox) {
    suggestionBox = document.createElement('ul')
    suggestionBox.id = suggestionBoxId
    suggestionBox.className = 'autocomplete-items'
    suggestionBox.setAttribute('role', 'listbox')
    suggestionBox.style.position = 'absolute'
    suggestionBox.style.zIndex = '1000'
    inputElement.parentNode?.appendChild(suggestionBox)
  }

  suggestionBox.innerHTML = ''

  suggestions.forEach((suggestion, index) => {
    const suggestionItem = document.createElement('li')
    suggestionItem.textContent = suggestion.label
    suggestionItem.setAttribute('role', 'option')
    suggestionItem.setAttribute('tabindex', '0')
    suggestionItem.className = 'autocomplete-item'

    // Click support
    suggestionItem.addEventListener('click', () => {
      inputElement.value = suggestion.value
      suggestionBox!.innerHTML = ''
      inputElement.focus()
    })

    // Keyboard Enter support when using Tab to focus
    suggestionItem.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        inputElement.value = suggestion.value
        suggestionBox!.innerHTML = ''
        inputElement.focus()
      }
    })

    // Sync currentFocus when using Tab
    suggestionItem.addEventListener('focus', () => {
      currentFocus = index
    })

    suggestionBox.appendChild(suggestionItem)
  })
}

document.addEventListener('click', (e) => {
  const target = e.target as HTMLElement
  const openList = document.querySelector('.autocomplete-items')

  if (
    openList &&
    currentInput &&
    !openList.contains(target) &&
    target !== currentInput
  ) {
    openList.remove()
    currentFocus = -1
    currentInput = null
  }
})
